

export const EMOJI = {
    SAD: '😟',
    INVALID: '⛔️',
    SORRY: '😓',
    ATTENTION: '❗️'
}